<template>
  <!-- TODO: clean and organize styles and code -->
  <!-- TODO: fragment code into component so there's not such a big chunk of code here-->
  <div id="bar" :style="restaurant.section_bg_one">
    <!-- Medium devices and up -->
    <div v-if="$vuetify.breakpoint.smAndUp">
      <v-container fluid pa-0>
        <!-- Toolbar-->
        <v-toolbar
          :style="restaurant.section_bg_two"
          :color="
            restaurant.accent_color_bar == undefined
              ? default_accent_color_bar
              : restaurant.accent_color_bar
          "
          height="100px"
          app
        >
          <v-spacer></v-spacer>

          <!-- Restaurant logo -->
          <div @click="scrollTo('bar')" style="height: 100px">
            <img
              class="cursor_pointer restaurant_logo"
              :src="restaurant.logo"
            />
          </div>

          <v-spacer></v-spacer>

          <!-- Items -->
          <v-toolbar-items>
            <v-btn
              :color="restaurant.accent_color_title"
              :dark="restaurant.dark_theme"
              flat
              class="toolbar-custom-title title font-weight-bold"
              @click="scrollTo('menu')"
            >
              <div class="golden_color">{{ getTranslation("menu") }}</div>
            </v-btn>
            <v-btn
              :color="restaurant.accent_color_title"
              :dark="restaurant.dark_theme"
              flat
              class="toolbar-custom-title title font-weight-bold"
              @click="scrollTo('services')"
            >
              <div class="golden_color">{{ getTranslation("services") }}</div>
            </v-btn>
            <v-btn
              :color="restaurant.accent_color_title"
              :dark="restaurant.dark_theme"
              flat
              class="toolbar-custom-title title font-weight-bold"
              @click="scrollTo('catering')"
            >
              <div class="golden_color">{{ getTranslation("catering") }}</div>
            </v-btn>
            <v-btn
              :color="restaurant.accent_color_title"
              :dark="restaurant.dark_theme"
              flat
              class="toolbar-custom-title title font-weight-bold"
              @click="scrollTo('about')"
            >
              <div class="golden_color">{{ getTranslation("contact") }}</div>
            </v-btn>
            <v-btn
              :color="restaurant.accent_color_title"
              :dark="restaurant.dark_theme"
              flat
              class="toolbar-custom-title title font-weight-bold"
              @click="scrollTo('book')"
            >
              <div class="golden_color">{{ getTranslation("book-table") }}</div>
            </v-btn>

            <v-btn
              :color="restaurant.accent_color_title"
              :dark="restaurant.dark_theme"
              flat
              class="toolbar-custom-title title font-weight-bold"
              @click="scrollTo('about-seville')"
            >
              <div class="golden_color">
                {{ getTranslation("about-sevilla") }}
              </div>
            </v-btn>
          </v-toolbar-items>

          <v-spacer></v-spacer>

          <!-- Highlighted Info -->
          <v-flex>
            <v-btn
              @click="orderFlipdish()"
              x-large
              flat
              style="height: 7vh; font-size: 2.5vh"
              class="golden_background white--text bounce"
              >{{ getTranslation("order-food") }}</v-btn
            >
          </v-flex>
          <!--<v-flex
            v-if="restaurant.appBarExtra"
            class="cursor_pointer text-xs-center toolbar-custom-title title font-weight-bold"
          >
            <a
              class="golden_color"
              :style="'color:'+ restaurant.accent_color_title +'!important;'"
              :href="'tel:'+restaurant.phone"
            >
              
              <br />
              {{restaurant.phone.substring(0,3) + ' ' + restaurant.phone.substring(3,6)+ ' ' + restaurant.phone.substring(6,9)}}
              <br />
              {{getTranslation('help-choose')}}
            </a>
          </v-flex>-->
        </v-toolbar>

        <!-- Content -->
        <div :class="[carousel_open ? blurClass : '', bkClass]">
          <!-- Banner -->
          <v-layout>
            <v-flex xs12>
              <!-- Carousel-->
              <v-carousel
                hide-controls
                hide-delimiters
                class="carousel_layout_wide"
                v-if="restaurant.banner_images"
              >
                <v-carousel-item
                  v-for="img in restaurant.banner_images"
                  :key="img"
                  :src="img"
                ></v-carousel-item>
              </v-carousel>

              <!-- Opacity-->
              <v-img xs12 height="500px" :style="restaurant.banner_opacity">
                <!-- Banner content-->
                <v-layout
                  text-xs-center
                  align-center
                  fill-height
                  :style="restaurant.banner_cover"
                >
                  <v-flex xs12 mb-5>
                    <h1
                      :style="
                        restaurant.accent_color_title == undefined
                          ? 'color:white; border-color:white;'
                          : 'color:' +
                            restaurant.accent_color_title +
                            ';' +
                            'border-color:' +
                            restaurant.accent_color_title +
                            ';'
                      "
                      class="slogan-title-border display-3 pa-5 font-weight-bold"
                    >
                      {{ restaurantInfo.slogan }}
                    </h1>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-flex>
          </v-layout>

          <!-- Featured dishes -->
          <section id="menu" class="pa-5">
            <v-layout row wrap>
              <v-flex text-xs-center xs12 mt-5 mb-5>
                <h1 class="custom-headline headline font-weight-bold">
                  {{ getTranslation("the_chef") }}
                </h1>
                <h1
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="custom-display-3 display-3 pa-1 font-weight-bold"
                >
                  {{ getTranslation("recommends") }}
                </h1>
                <!--Underline-->
                <svg height="18px">
                  <line
                    x1="0"
                    y1="0"
                    x2="700"
                    y2="0"
                    :style="
                      'stroke:' +
                      restaurant.accent_color_font +
                      ';stroke-width:18px'
                    "
                  />
                </svg>
              </v-flex>

              <v-layout row wrap style="width: 100%" class="mx-5 pa-5">
                <v-flex
                  class="cursor_pointer"
                  xs4
                  v-for="(dish, index) in dishes_featured"
                  :key="dish.id"
                >
                  <v-img
                    @click.native="show(index)"
                    aspect-ratio="1"
                    height="300px"
                    :src="dish.image"
                  ></v-img>
                </v-flex>
              </v-layout>

              <v-flex pt-5 text-xs-center xs12>
                <v-btn
                  @click="checkMenu"
                  x-large
                  style="height: 7vh; font-size: 2.5vh"
                  class="golden_background"
                  :color="
                    restaurant.accent_color_font == undefined
                      ? 'white'
                      : restaurant.accent_color_font
                  "
                  dark
                  >{{ getTranslation("see-menu") }}</v-btn
                >

                <v-btn
                  @click="orderFlipdish()"
                  x-large
                  style="height: 7vh; font-size: 2.5vh"
                  class="golden_background white--text"
                  >{{ getTranslation("order-food") }}</v-btn
                >
              </v-flex>
            </v-layout>
          </section>

          <!-- Services -->
          <section id="services">
            <v-layout column wrap align-center>
              <v-flex text-xs-center xs12 mt-5 mb-2>
                <h1
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="custom-display-3 display-3 pa-1 font-weight-bold"
                >
                  {{ getTranslation("services") }}
                </h1>
                <svg height="18px">
                  <line
                    x1="0"
                    y1="0"
                    x2="700"
                    y2="0"
                    :style="
                      'stroke:' +
                      restaurant.accent_color_font +
                      ';stroke-width:18px'
                    "
                  />
                </svg>
              </v-flex>
              <v-flex xs12>
                <v-container class="custom_container" grid-list-xl>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_one"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="custom-headline headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_one }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_one }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_two"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="custom-headline headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_two }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_two }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_three"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="custom-headline headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_three }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_three }}</v-card-text
                        >
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_four"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="custom-headline headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_four }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_four }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_five"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="custom-headline headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_five }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_five }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_six"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="custom-headline headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_six }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_six }}</v-card-text
                        >
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </section>

          <!-- Deals -->
          <section id="deals">
            <v-parallax :src="restaurant.deal_image" height="380">
              <v-layout column align-center justify-center>
                <h1
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="mb-2 deal_banner_text text-xs-center font-weight-bold"
                >
                  {{ restaurantInfo.deal }}
                </h1>
                <p
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="custom-headline headline font-weight-bold"
                >
                  {{ restaurantInfo.deal_desc }}
                </p>
              </v-layout>
            </v-parallax>
          </section>

          <!-- Catering -->
          <v-flex id="catering" text-xs-center xs12 pa-5 mt-5 mb-2>
            <h1
              :style="
                restaurant.accent_color_font == undefined
                  ? 'color:white;'
                  : 'color:' + restaurant.accent_color_font + ';'
              "
              class="custom-display-3 display-3 pa-1 font-weight-bold"
            >
              {{ getTranslation("catering") }}
            </h1>
            <svg height="18px">
              <line
                x1="0"
                y1="0"
                x2="700"
                y2="0"
                :style="
                  'stroke:' +
                  restaurant.accent_color_font +
                  ';stroke-width:18px'
                "
              />
            </svg>
          </v-flex>
          <catering :restaurant="restaurant"></catering>

          <!-- About -->

          <!-- About Small Devices -->
          <section id="about" class="pa-5">
            <v-layout v-if="restaurant.about_images" text-xs-center row wrap>
              <v-flex xs12 mt-5>
                <h1
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="display-3 pa-1 font-weight-bold"
                >
                  {{ restaurant.name }}
                </h1>
                <svg height="18px">
                  <line
                    x1="0"
                    y1="0"
                    x2="700"
                    y2="0"
                    :style="
                      'stroke:' +
                      restaurant.accent_color_font +
                      ';stroke-width:18px'
                    "
                  />
                </svg>

                <h1
                  class="headline font-weight-bold"
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                >
                  {{ restaurant.address }}
                </h1>
                <h1
                  class="custom-display-2 display-2 font-weight-bold"
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                >
                  {{
                    restaurant.phone.substring(0, 3) +
                    " " +
                    restaurant.phone.substring(3, 6) +
                    " " +
                    restaurant.phone.substring(6, 9)
                  }}
                </h1>
                <h1
                  class="px-5 custom-caption caption font-weight-bold"
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                >
                  {{ restaurantInfo.opening_hours }}
                </h1>
              </v-flex>

              <!-- About Text -->
              <!-- TODO: make this more dynamic -->
              <v-flex pt-4 xs12>
                <div v-if="$vuetify.breakpoint.mdAndUp">
                  <v-layout
                    container
                    align-center
                    justify-content-center
                    row
                    wrap
                    class="custom_container"
                  >
                    <v-flex xs12 md6 pr-5 pb-5>
                      <v-img
                        aspect-ratio="1"
                        height="300px"
                        :src="restaurant.about_images[0]"
                      ></v-img>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                      pb-5
                      class="custom-title title text_left"
                      >{{ restaurantInfo.about_us_one }}</v-flex
                    >

                    <v-flex
                      xs12
                      md6
                      pb-5
                      class="custom-title title text_left"
                      >{{ restaurantInfo.about_us_two }}</v-flex
                    >
                    <v-flex xs12 md6 pl-5 pb-5>
                      <v-img
                        aspect-ratio="1"
                        height="300px"
                        :src="restaurant.about_images[1]"
                      ></v-img>
                    </v-flex>

                    <v-flex xs12 md6 pr-5 pb-5>
                      <v-img
                        aspect-ratio="1"
                        height="300px"
                        :src="restaurant.about_images[2]"
                      ></v-img>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                      pb-5
                      class="custom-title title text_left"
                      >{{ restaurantInfo.about_us_three }}</v-flex
                    >
                  </v-layout>
                </div>
                <div v-else>
                  <v-layout
                    container
                    align-center
                    justify-content-center
                    row
                    wrap
                    class="custom_container"
                  >
                    <v-flex xs12 pb-5>
                      <v-img
                        aspect-ratio="1"
                        height="300px"
                        :src="restaurant.about_images[0]"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 pb-5 class="custom-title title text--center">{{
                      restaurantInfo.about_us_one
                    }}</v-flex>

                    <v-flex xs12 pb-5>
                      <v-img
                        aspect-ratio="1"
                        height="300px"
                        :src="restaurant.about_images[1]"
                      ></v-img>
                    </v-flex>

                    <v-flex xs12 pb-5 class="custom-title title text--center">{{
                      restaurantInfo.about_us_two
                    }}</v-flex>

                    <v-flex xs12 pb-5>
                      <v-img
                        aspect-ratio="1"
                        height="300px"
                        :src="restaurant.about_images[2]"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 pb-5 class="custom-title title text--center">{{
                      restaurantInfo.about_us_three
                    }}</v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </section>

          <div v-if="$vuetify.breakpoint.smAndUp">
            <!-- Book a table -->
            <section id="book" class="pa-5">
              <v-layout column justify-center>
                <!-- Booking text -->
                <h1 class="headline font-weight-bold text-xs-center">
                  {{ this.getTranslation("book_table_info") }}
                </h1>
                <h1
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="display-2 text-xs-center pa-1 font-weight-bold mb-4"
                >
                  {{ this.getTranslation("book-your-table") }}
                </h1>

                <iframe
                  v-if="this.$i18n.locale() == 'es'"
                  id="restaurante-taj-mahal-sevilla"
                  title="Reservas"
                  src="https://www.covermanager.com/reserve/module_restaurant/restaurante-taj-mahal-sevilla/spanish"
                  frameborder="0"
                  height="550"
                  width="100%"
                  onload="if (window.iFrameResize) iFrameResize();"
                >
                </iframe>

                <iframe
                  v-else
                  id="restaurante-taj-mahal-sevilla"
                  title="Reservas"
                  src="https://www.covermanager.com/reserve/module_restaurant/restaurante-taj-mahal-sevilla/english"
                  frameborder="0"
                  height="550"
                  width="100%"
                  onload="if (window.iFrameResize) iFrameResize();"
                >
                </iframe>

                <v-spacer></v-spacer>

                <!-- Google Maps -->
                <iframe
                  class="pa-5"
                  :src="restaurant.googleMapUrl"
                  width="100%"
                  height="500vh"
                  frameborder="0"
                  style="border: 0"
                  allowfullscreen
                ></iframe>
                <v-spacer></v-spacer>
              </v-layout>
            </section>
            <about-sevilla
              id="about-seville"
              :restaurant="restaurant"
            ></about-sevilla>
          </div>
        </div>

        <!-- End content-->
      </v-container>
    </div>

    <!-- Dish carousel : hidden until dish clicked-->
    <transition name="fade">
      <div class="lightbox" v-if="carousel_open" @click.stop="hide">
        <v-flex wrap>
          <v-img
            contain
            ma-5
            aspect-ratio="1"
            height="55vh"
            :src="dishes_featured[chosen_index].image"
          >
          </v-img>

          <v-layout
            wrap
            column
            fill-height
            align-center
            justify-center
            ma-5
            mb-2
          >
            <!-- Title -->
            <div class="dish_title">
              {{ dishes_featured[chosen_index].name }}
            </div>
            <!-- Description -->
            <div class="custom_title title dish_description">
              {{ dishes_featured[chosen_index].description }}
            </div>

            <!-- Close -->
            <v-btn
              icon
              flat
              style="position: absolute; margin-top: 20vh !important"
            >
              <v-icon style="color: #424242" x-large>close</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </div>
    </transition>

    <!-- Small devices -->
    <div v-if="$vuetify.breakpoint.xsOnly">
      <!-- Restaurant banner -->
      <v-card class="restaurant_page_container">
        <v-carousel
          v-if="restaurant.banner_images"
          hide-controls
          hide-delimiters
          class="carousel_layout"
        >
          <v-carousel-item
            style="height: 300px !important"
            :src="restaurant.banner_images[0]"
          ></v-carousel-item>

          <v-carousel-item
            style="height: 300px !important"
            :src="restaurant.banner_images[1]"
          ></v-carousel-item>

          <v-carousel-item
            style="height: 300px !important"
            :src="restaurant.banner_images[2]"
          ></v-carousel-item>
        </v-carousel>

        <v-img height="300px" :style="restaurant.banner_opacity">
          <v-layout column fill-height :style="restaurant.banner_cover">
            <v-card-title>
              <!-- Restaurant logo -->
              <img class="restaurant_logo_small" :src="restaurant.logo" />
              <v-spacer></v-spacer>

              <div class="phone-icons-container">
                <!-- Restaurant directions -->
                <v-tooltip left slot="activator">
                  <v-btn
                    slot="activator"
                    class="pa-4 mr-2"
                    icon
                    color="white"
                    :href="restaurant.googleDirectionsUrl"
                  >
                    <v-icon
                      medium
                      :color="restaurant.accent_color_font"
                      class="golden_color"
                      >directions</v-icon
                    >
                  </v-btn>

                  <span>{{ getTranslation("google-directions") }}</span>
                </v-tooltip>

                <!-- Whatssap Restaurant -->
                <v-btn
                  v-if="restaurant.useWhatssap"
                  slot="activator"
                  class="pa-4 mr-2"
                  icon
                  color="white"
                  target="_blank"
                  :href="'https://wa.me/' + restaurant.phoneWhatssap"
                >
                  <i class="fab fa-whatsapp fa-2x golden_color"></i>
                </v-btn>

                <!-- Call Restaurant -->
                <v-tooltip left slot="activator">
                  <v-btn
                    slot="activator"
                    class="pa-4 mr-2"
                    icon
                    color="white"
                    :href="'tel:' + restaurant.phone"
                  >
                    <v-icon
                      medium
                      :color="restaurant.accent_color_font"
                      class="golden_color"
                      >phone</v-icon
                    >
                  </v-btn>

                  <span>{{ getTranslation("order-home") }}</span>
                </v-tooltip>
              </div>
            </v-card-title>
            <v-spacer></v-spacer>

            <v-snackbar v-model="bookingSnackbar" style="position: absolute">
              {{ this.getTranslation("table_booked") }}

              <template>
                <v-btn text flat color="white" @click="bookingSnackbar = false">
                  {{ this.getTranslation("close") }}
                </v-btn>
              </template>
            </v-snackbar>

            <v-card-title class="text-xs-center white--text pt-3">
              <!-- Reservation button and dialog for phones-->
              <div class="text-xs-center xs-6">
                <v-dialog v-model="dialogBooking" width="500">
                  <v-btn
                    slot="activator"
                    :disabled="booked"
                    class="silver_background"
                    dark
                    >{{ getTranslation("book_a_table") }}</v-btn
                  >

                  <v-card>
                    <v-form v-model="valid_booking" ref="bookingForm">
                      <!-- Booking text -->
                      <h1 class="headline font-weight-bold text-xs-center pt-5">
                        {{ this.getTranslation("book_table_info") }}
                      </h1>
                      <h1
                        :style="
                          restaurant.accent_color_font == undefined
                            ? 'color:white;'
                            : 'color:' + restaurant.accent_color_font + ';'
                        "
                        class="display-2 text-xs-center pa-1 font-weight-bold"
                      >
                        {{ this.getTranslation("book-your-table") }}
                      </h1>

                      <v-container mt-3 grid-list-md>
                        <v-layout wrap>
                          <iframe
                            v-if="this.$i18n.locale() == 'es'"
                            id="restaurante-taj-mahal-sevilla"
                            title="Reservas"
                            src="https://www.covermanager.com/reserve/module_restaurant/restaurante-taj-mahal-sevilla/spanish"
                            frameborder="0"
                            height="550"
                            width="100%"
                            onload="if (window.iFrameResize) iFrameResize();"
                          >
                          </iframe>

                          <iframe
                            v-else
                            id="restaurante-taj-mahal-sevilla"
                            title="Reservas"
                            src="https://www.covermanager.com/reserve/module_restaurant/restaurante-taj-mahal-sevilla/english"
                            frameborder="0"
                            height="550"
                            width="100%"
                            onload="if (window.iFrameResize) iFrameResize();"
                          >
                          </iframe>
                        </v-layout>
                      </v-container>
                    </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="this.restaurant"
                        :color="
                          restaurant.accent_color_font == undefined
                            ? 'amber darken-1'
                            : restaurant.accent_color_font
                        "
                        dark
                        flat
                        @click="dialogBooking = false"
                        >{{ getTranslation("close") }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <v-spacer></v-spacer>

              <!-- Flipdish delivery-->
              <div class="text-xs-center xs-6">
                <v-btn @click="orderFlipdish()" class="golden_background" dark>
                  <div>{{ getTranslation("order-food") }}</div>
                </v-btn>
              </div>
            </v-card-title>
          </v-layout>
        </v-img>

        <!-- Full Menu Phone -->
        <div @click="checkMenu">
          <v-expansion-panel class="elevation-0 mobile-collapse" readonly flat>
            <v-expansion-panel-content class="mobile-collapse-content" flat>
              <template v-slot:header>
                <div
                  class="golden_color text-xs-center custom-display-phone display-2 font-weight-bold"
                >
                  {{ getTranslation("menu") }}
                </div>
              </template>
              <v-card class="mobile-collapse-content">
                <v-layout row>
                  <v-flex xs12 sm6 offset-sm3>
                    <v-list
                      id="menu-phone"
                      :style="restaurant.section_bg_one"
                      avatar
                      three-line
                      subheader
                      style="padding: 0px"
                    >
                      <v-list-group
                        v-for="category in categories"
                        :key="category.id"
                        no-action
                      >
                        <v-list-tile slot="activator">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <div class="golden_color title font-weight-bold">
                                {{ category.name }}
                              </div>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <!-- Dishes-->
                        <v-list-tile
                          v-for="dish in loadDishesByCategory(category.id)"
                          :key="dish.id"
                          class="dish_tiles"
                        >
                          <v-list-tile-action>
                            <v-avatar class="avatar">
                              <v-img
                                v-if="dish.image.length > 10"
                                :src="dish.image"
                              ></v-img>
                            </v-avatar>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title>
                              <div
                                class="font-weight-bold"
                                style="color: #424242"
                              >
                                {{ dish.name }}
                              </div>
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              <div style="color: #424242">
                                {{ dish.description }}
                              </div>
                            </v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-list-tile-title>
                              <div class="listPrice">
                                {{ dish.price + " " + restaurant.currency }}
                              </div>
                            </v-list-tile-title>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list-group>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </v-card>

      <!-- Services for phones -->
      <v-expansion-panel class="elevation-0 mobile-collapse" flat>
        <v-expansion-panel-content class="mobile-collapse-content" flat>
          <template v-slot:header>
            <div
              class="golden_color text-xs-center custom-display-phone display-2 font-weight-bold"
            >
              {{ getTranslation("services") }}
            </div>
          </template>
          <v-card class="mobile-collapse-content">
            <v-layout column wrap align-center>
              <v-flex xs12>
                <v-container class="custom_container" grid-list-xl>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_one"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="golden_color custom-headline-phone headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_one }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title-phone title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_one }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_two"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="golden_color custom-headline-phone headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_two }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title-phone title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_two }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_three"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="golden_color custom-headline-phone headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_three }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title-phone title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_three }}</v-card-text
                        >
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_four"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="golden_color custom-headline-phone headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_four }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title-phone title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_four }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_five"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="golden_color custom-headline-phone headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_five }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title-phone title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_five }}</v-card-text
                        >
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                          <img
                            class="service_icon"
                            :src="restaurant.service_logo_six"
                          />
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout text-xs-center justify-center"
                        >
                          <h1
                            class="golden_color custom-headline-phone headline text-xs-center font-weight-bold"
                          >
                            {{ restaurantInfo.service_title_six }}
                          </h1>
                        </v-card-title>
                        <v-card-text
                          class="custom-title-phone title pt-0 text-xs-center"
                          >{{ restaurantInfo.service_desc_six }}</v-card-text
                        >
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Catering -->
      <v-expansion-panel class="elevation-0 mobile-collapse" flat>
        <v-expansion-panel-content class="mobile-collapse-content" flat>
          <template v-slot:header>
            <div
              class="golden_color text-xs-center custom-display-phone display-2 font-weight-bold"
            >
              {{ getTranslation("catering") }}
            </div>
          </template>
          <v-card class="mobile-collapse-content">
            <catering :restaurant="restaurant"></catering>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- About for phones -->
      <v-expansion-panel class="elevation-0 mobile-collapse" flat>
        <v-expansion-panel-content class="mobile-collapse-content" flat>
          <template v-slot:header>
            <div
              class="golden_color text-xs-center custom-display-phone display-2 font-weight-bold"
            >
              {{ getTranslation("about-us") }}
            </div>
          </template>
          <v-card class="mobile-collapse-content">
            <v-layout v-if="restaurant.about_images" text-xs-center row wrap>
              <v-flex xs12 mt-5>
                <h1
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                  class="custom-display-phone display-2 font-weight-bold"
                >
                  {{ restaurant.name }}
                </h1>
                <svg height="18px">
                  <line
                    x1="0"
                    y1="0"
                    x2="700"
                    y2="0"
                    :style="
                      'stroke:' +
                      restaurant.accent_color_font +
                      ';stroke-width:16px'
                    "
                  />
                </svg>

                <h1
                  class="headline font-weight-bold"
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                >
                  {{ restaurant.address }}
                </h1>
                <h1
                  class="custom-display-2 display-2 font-weight-bold"
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                >
                  {{
                    restaurant.phone.substring(0, 3) +
                    " " +
                    restaurant.phone.substring(3, 6) +
                    " " +
                    restaurant.phone.substring(6, 9)
                  }}
                </h1>

                <h1
                  class="px-2 custom-caption-phone caption font-weight-bold"
                  :style="
                    restaurant.accent_color_font == undefined
                      ? 'color:white;'
                      : 'color:' + restaurant.accent_color_font + ';'
                  "
                >
                  {{ restaurantInfo.opening_hours }}
                </h1>
              </v-flex>

              <!-- About Text -->
              <v-flex pt-2 xs12>
                <v-layout
                  id="about-text-div"
                  container
                  align-center
                  justify-content-center
                  row
                  wrap
                  class="custom_container"
                >
                  <v-flex xs12 pb-2>
                    <v-img
                      aspect-ratio="1"
                      height="300px"
                      :src="restaurant.about_images[0]"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    xs12
                    pb-5
                    class="custom-title-phone title text--center about-text"
                    >{{ restaurantInfo.about_us_one }}</v-flex
                  >

                  <v-flex xs12 pb-2>
                    <v-img
                      aspect-ratio="1"
                      height="300px"
                      :src="restaurant.about_images[1]"
                    ></v-img>
                  </v-flex>

                  <v-flex
                    xs12
                    pb-5
                    class="custom-title-phone title text--center about-text"
                    >{{ restaurantInfo.about_us_two }}</v-flex
                  >

                  <v-flex xs12 pb-2>
                    <v-img
                      aspect-ratio="1"
                      height="300px"
                      :src="restaurant.about_images[2]"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    xs12
                    pb-5
                    class="custom-title-phone title text--center about-text"
                    >{{ restaurantInfo.about_us_three }}</v-flex
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- About sevilla -->
      <v-expansion-panel class="elevation-0 mobile-collapse" flat>
        <v-expansion-panel-content class="mobile-collapse-content" flat>
          <template v-slot:header>
            <div
              class="golden_color text-xs-center custom-display-phone display-2 font-weight-bold"
            >
              {{ getTranslation("about-sevilla") }}
            </div>
          </template>
          <v-card class="mobile-collapse-content">
            <about-sevilla
              id="about-seville"
              :restaurant="restaurant"
            ></about-sevilla>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Deals for Phones -->
      <section>
        <v-parallax :src="restaurant.deal_image" height="250">
          <v-layout column align-center justify-center>
            <h1
              :style="
                restaurant.accent_color_font == undefined
                  ? 'color:white;'
                  : 'color:' + restaurant.accent_color_font + ';'
              "
              class="mb-2 display-1 text-xs-center font-weight-bold"
            >
              {{ restaurantInfo.deal }}
            </h1>
            <p
              :style="
                restaurant.accent_color_font == undefined
                  ? 'color:white;'
                  : 'color:' + restaurant.accent_color_font + ';'
              "
              class="custom_title title font-weight-bold"
            >
              {{ restaurantInfo.deal_desc }}
            </p>
          </v-layout>
        </v-parallax>
      </section>
    </div>

    <!--Footer-->
    <section>
      <v-footer @click.native.stop class="pa-3 white">
        <div class="footer-signature">
          <div>
            {{ new Date().getFullYear() }}
            <strong>&copy; {{ restaurant.name }}</strong>
          </div>
          <div>
            &nbsp; &nbsp; ─ &nbsp;&nbsp; {{ getTranslation("made-with") }}
            <v-icon small color="red">favorite</v-icon>
            &nbsp;{{ getTranslation("by") }}
            <strong>
              <a target="_blank" href="https://alio.li">alio.li</a>
            </strong>
          </div>
        </div>
      </v-footer>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import aboutSevilla from "./AboutSevilla";
import catering from "./Catering";

export default {
  name: "home",
  components: {
    aboutSevilla,
    catering,
  },
  data() {
    return {
      // restaurant id to serve
      restaurant_id: "tajmahalsevilla",
      default_accent_color_bar: "white",
      default_accent_color_font: "#424242",
      carousel_open: false,
      carousel_index: 0,
      chosen_index: 0,
      bkClass: "bk",
      blurClass: "blur",
      dialogEmail: false,
      dialogBooking: false,
      emailRules: [
        (v) => !!v || this.getTranslation("email-required"),
        (v) => /.+@.+/.test(v) || this.getTranslation("email-valid"),
      ],
      hourRules: [(v) => v != null || this.getTranslation("hour-required")],
      phoneRules: [(v) => !!v || this.getTranslation("phone-required")],
      contactEmail: "",
      bookingPhone: "", // Contact email from the subscribe dialog.
      bookingEmail: "",
      bookingName: "",
      bookingMessage: "",
      booked: false,
      subscribed: false, // If this user subscribed, to change subscribed btn.
      valid: false,
      valid_booking: false,
      rangeOfPeople: [...Array(21).keys()].slice(1),
      numberPeople: 1,
      datePickerDialog: false,
      pickedDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      oldDate: new Date(),
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      closeDates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).setDate(
          new Date().getDate() + 1
        ),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).setDate(
          new Date().getDate() + 2
        ),
      ],
      showPreviousDate: false,
      bookingType: "Comida",
      afternoonHours: [
        // Horario maximo de reserva hasta las 15.45 ó las 22.45
        "12:00",
        "12:15",
        "12:30",
        "12:45",
        "13:00",
        "13:15",
        "13:30",
        "13:45",
        "14:00",
        "14:15",
        "14:30",
        "14:45",
        "15:00",
        "15:15",
        "15:30",
        "15:45",
      ],
      dinnerHours: [
        "20:00",
        "20:15",
        "20:30",
        "20:45",
        "21:00",
        "21:15",
        "21:30",
        "21:45",
        "22:00",
        "22:15",
        "22:30",
        "22:45",
      ],
      selectedHour: null,
      activeDayButton: 0,
      showBookingSelection: false,
      bookingSnackbar: false,
      showFirstTimeSelection: false,
    };
  },
  created() {
    //console.log("\nToday is: " + new Date().toISOString() + "\n");
    this.$store.dispatch("loadRestaurantInfo", this.restaurant_id);
    this.$store.dispatch("loadCategories", this.restaurant_id);
    this.$store.dispatch("loadDishes", this.restaurant_id);
    this.$store.dispatch("loadRestaurant", this.restaurant_id);
  },
  mounted() {
    window.addEventListener("keydown", this.eventListener);
    // Reservation integrations belong to the home page; they must not block the menu.
    [
      ['cover-resizer', 'https://www.covermanager.com/js/iframeResizer.min.js'],
      ['cover-tracking', 'https://www.covermanager.com/reserve/gtmcrossdomain/restaurante-taj-mahal-sevilla'],
    ].forEach(([id, src]) => {
      if (document.getElementById(id)) return;
      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      if (id === 'cover-resizer') script.onload = () => { if (window.iFrameResize) window.iFrameResize(); };
      document.head.appendChild(script);
    });
  },
  destroyed() {
    window.removeEventListener("keydown", this.eventListener);
  },
  computed: {
    bookTableMessages() {
      return this.showBookingSelection
        ? [this.getTranslation("terrace")]
        : [this.getTranslation("lounge")];
    },
    firstTimeMessages() {
      return this.showFirstTimeSelection
        ? [this.getTranslation("no")]
        : [this.getTranslation("yes")];
    },
    isTodayorTomorrow() {
      let chosenDate = new Date(this.pickedDate);
      let tomorrow = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      ).setDate(new Date().getDate() + 1);
      let aftertomorrow = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      ).setDate(new Date().getDate() + 2);
      return (
        this.pickedDate == this.today ||
        this.pickedDate == new Date(tomorrow).toISOString().substr(0, 10) ||
        this.pickedDate == new Date(aftertomorrow).toISOString().substr(0, 10)
      );
    },
    dishes() {
      return this.$store.getters.loadedDishes;
    },
    dishes_featured() {
      return this.dishes.filter((x) => x.featured);
    },
    // Needed for dishes carousel:
    re_ordered_dishes() {
      let dishes_copy = this.dishes_featured.slice(
        this.chosen_index,
        this.dishes.length
      );
      dishes_copy = dishes_copy.concat(
        this.dishes_featured.slice(0, this.chosen_index)
      );
      return dishes_copy;
    },
    categories() {
      return this.$store.getters.loadedCategories;
    },
    restaurantInfo() {
      return this.$store.getters.loadedRestaurantInfo;
    },
    restaurant() {
      return this.$store.getters.loadedRestaurant;
    },
  },
  methods: {
    // Get translation must be first if used in other methods
    getTranslation(key) {
      return this.$t(key);
    },
    checkMenu() {
      this.$router.replace({name: "MenuPage"});
    },
    orderFlipdish() {
      let routeData = this.$router.resolve({
        name: "DeliveryPage",
      });
      window.open(routeData.href, "_blank");
    },
    loadDishesByCategory(categoryId) {
      return this.dishes.filter((dish) => {
        return dish.category_id === categoryId;
      });
    },
    subscribeSubmit() {
      if (this.contactEmail === "") {
        return;
      }
      this.$store
        .dispatch("saveEmail", {
          restaurantId: this.restaurant_id,
          email: this.contactEmail.toLowerCase(),
        })
        .then(() => {
          this.subscribed = true;
          this.dialogEmail = false;
        });
    },
    // Scroll method
    scrollTo(elementId) {
      document.getElementById(elementId).scrollIntoView({
        behavior: "smooth",
      });
    },
    // Carousel methods
    updateIndex(index) {
      this.carousel_index = index;
    },
    show(index) {
      this.chosen_index = index;
      this.carousel_open = true;
    },
    hide() {
      this.carousel_open = false;
    },
    eventListener(e) {
      if (this.isOpen) {
        switch (e.key) {
          case " ":
            e.preventDefault();
            break;
          case "Escape":
            this.hide();
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
@import "custom_styles.css";
@import "./web-fonts-with-css/css/fontawesome-all.css";
/* General CSS */

a {
  text-decoration: none;
}
/* Overriding font-sizes */

.custom-display-2 {
  line-height: 1.6 !important;
  font-size: 44px !important;
}

.custom-display-3 {
  line-height: 1.6 !important;
  font-size: 82px !important;
}

.custom-display-phone {
  line-height: 1.6 !important;
  font-size: 42px !important;
}

.deal_banner_text {
  line-height: 1.2;
  font-size: 64px !important;
}

.custom-headline {
  color: #212121;
  line-height: 1.6 !important;
  font-size: 44px !important;
}

.custom-headline-phone {
  line-height: 1.6 !important;
  font-size: 36px !important;
}
.custom-caption {
  font-size: 16px !important;
}
.custom-caption-phone {
  font-size: 14px !important;
}
.custom-title {
  color: #424242;
  line-height: 1.2 !important;
}

.custom-title-phone {
  color: #424242;
  line-height: 1.2 !important;
  padding: 0px !important;
}

/* End overriding font-sizes */

.text_left {
  text-align: left;
}

.slogan-title-border {
  display: inline-block;
  border-style: solid;
  border-color: white;
  border-width: 14px;
}

.headline-border {
  display: inline-block;
  border-style: solid;
  border-color: white;
  border-width: 6px;
}

.carousel_layout_wide {
  height: 500px !important;
  position: absolute;
  width: 100%;
  /* Deleting drop shadows*/
  -webkit-box-shadow: unset !important;
  box-shadow: unset !important;
}

.carousel_layout {
  height: 300px !important;
  position: absolute;
  width: 100%;
  /* Deleting drop shadows*/
  -webkit-box-shadow: unset !important;
  box-shadow: unset !important;
}

.restaurant_page_container {
  /* Deleting drop shadows*/
  -webkit-box-shadow: unset !important;
  box-shadow: unset !important;
}
/* TODO: make these touchable if not make bigger */

.avatar {
  padding-right: 32px;
}

.listPrice {
  float: right;
  font-size: 14px;
}

.restaurantTitleSimple {
  padding-left: 12px !important;
  margin-left: 0px;
}

.restaurant_logo {
  max-height: 100%;
}

.restaurant_logo_small {
  position: absolute;
  top: 16px;
  left: 16px;
  max-height: 10vh;
}

.service_icon {
  max-height: 15vh;
}
/* Carousel styles */

.cursor_pointer {
  cursor: pointer;
}
/*Animations*/

.fade-enter-active,
.fade-leave-active {
  transition: all 128ms ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.bk {
  transition: all 128ms ease-in-out;
}

.blur {
  filter: blur(2px);
  opacity: 0.4;
}

.lightbox {
  cursor: pointer;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.dish_title {
  justify-content: space-evenly;
  text-align: center;
  font-weight: bold;
  padding: 8px;
  font-size: 2.5vh;
  cursor: pointer;
  color: rgb(33, 33, 33);
  /*width: 100%;*/
}

.dish_description {
  justify-content: space-evenly;
  text-align: center;
  cursor: pointer;
  color: rgb(66, 66, 66);
  /*width: 100%;*/
  font-size: 2vh;
}

.custom_container {
  max-width: max-content;
  padding: 48px;
}

.phone-icons-container {
  display: flex;
  flex-direction: column-reverse;
}

.footer-signature {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.mobile-collapse {
  background-color: transparent !important;
}

.mobile-collapse-content {
  background-color: transparent !important;
  border: none !important;
}

@media screen and (max-width: 992px) {
  #about-text-div {
    padding: 48px 0;
  }
  .about-text {
    padding: 10px 28px 40px 28px !important;
    text-align: justify;
  }
  #menu-phone {
    background-image: none !important;
    background: transparent !important;
    background-color: transparent !important;
  }
  #bar {
    background-color: white;
  }
  .theme--light.v-card {
    background-color: none !important;
  }
  #bar > div > div {
    background-color: transparent;
  }
}

.theme--light.application {
  background-attachment: fixed !important;
}

#showBookingSelection {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

@media screen and (min-width: 960px) {
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
  #showBookingSelectionFlex {
    margin-bottom: -25px !important;
  }
}

@media screen and (max-width: 960px) {
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
  #showBookingSelectionFlex {
    margin-bottom: -10px !important;
  }
  .v-text-field {
    padding-top: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RestaurantPage.vue